import type { RefundData, RefundDataRequest } from 'refunds/types/refundData'

export const isUniqueMethod = (
	refundData?: RefundData | RefundDataRequest | null
) => {
	if (!refundData) {
		return false
	}

	const methods = Object.values(refundData).filter((method) => {
		if (method === null) {
			return false
		}

		if (Object.prototype.hasOwnProperty.call(method, 'available')) {
			return method.available
		}

		return true
	})

	return methods.length === 1
}
